import { CSSObject } from '@chakra-ui/react';
import { TBodyTextProps } from '../types';

export const BodyText = ({ heading }: TBodyTextProps): CSSObject => ({
  '&&': {
    fontSize: heading ? 'sm' : 'xs',
    fontWeight: heading ? 'medium' : 'normal',
    color: 'gray.500',
    lineHeight: '1.3',
  },
});

export const RadioText: CSSObject = {
  '&&': {
    fontSize: 'xs',
    mb: '2',
    fontWeight: 'normal',
  },
};

export const DepositLimitContainer: CSSObject = {
  mt: '4',
  border: '1px dashed',
  borderColor: 'gray.300',
  borderRadius: 'base',
  p: '4',

  '.chakra-input__left-addon': {
    bg: 'gray.50',
    fontSize: 'xs',
    border: '1px solid',
    borderColor: 'gray.300',
    h: '9',
    color: 'gray.700',
  },
  '.chakra-select': {
    bg: 'gray.50',
    border: '1px',
    borderColor: 'gray.300',
    fontSize: 'xs',
  },
  '#limitAmount-input': {
    fontSize: 'xs',
    bg: 'gray.50',
    borderColor: 'gray.300',
    color: 'gray.600',
    h: '9',
    '&&:hover, &&:focus': {
      bg: 'gray.50',
    },
  },
};

export const FlexHeaderWrapper: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: ['4', null, '5'],
  pt: [null, null, '1'],
  gap: '2',
};

export const ButtonSubmit: CSSObject = {
  borderRadius: 'md',
  bg: 'beta.400',
  boxShadow:
    '0px -3px 4px 0px rgba(0, 0, 0, 0.20) inset, 0px 4px 4px 0px rgba(255, 255, 255, 0.15) inset, 0px 4px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
  color: 'alpha.600',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.30)',
  fontFamily: 'accent',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  fontSize: 'sm',

  _hover: {
    bg: 'beta.600',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.25), 0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
    color: 'alpha.800',
    textShadow: '0px 1px 1px rgba(255, 255, 255, 0.30)',
  },
};

export const RadioLimitChoice: CSSObject = {
  bg: 'gray.200',
  border: 'none',
  mb: '2',
  '&[data-checked]': {
    bg: 'alpha.400',
    borderWidth: '7px',
    borderStyle: 'solid',
    borderColor: 'gray.200',
    color: 'alpha.400',
  },
  '&[data-checked]:hover': {
    bg: 'alpha.400',
    borderWidth: '7px',
    borderStyle: 'solid',
    borderColor: 'gray.200',
    color: 'alpha.400',
  },
};
